import {
  type ProductCode,
  isPluginProduct,
} from '@common/api/productContext';

export const resolveProductDocumentTitle = (productCode: ProductCode) =>
  isPluginProduct(productCode) ? 'BizSidekick' : 'Bustly';

const normalizeAssetBaseUrl = (assetBaseUrl: string) =>
  assetBaseUrl.endsWith('/') ? assetBaseUrl : `${assetBaseUrl}/`;

export const resolveProductFavicon = (
  productCode: ProductCode,
  assetBaseUrl = '/',
) =>
  `${normalizeAssetBaseUrl(assetBaseUrl)}${
    isPluginProduct(productCode)
      ? 'bizsidekick-favicon.svg'
      : 'favicon.png'
  }`;
